var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui container"},[_c('div',{staticClass:"ui stackable four column grid"},_vm._l((_vm.courses),function(item){return _c('StuCourse',{key:item.id,attrs:{"course":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }